import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { groupsService } from "@/services/groupsService";
/** Owner groups of the acting company, fetched once and shared by every picker (a company switch reloads the page). */
export const useGroupsStore = defineStore("groups-store", () => {
    const groups = ref([]);
    const loading = ref(false);
    const loaded = ref(false);
    let inFlight = null;
    const byId = computed(() => new Map(groups.value.map((group) => [group.id, group])));
    async function fetchGroups({ force = false } = {}) {
        if (loaded.value && !force)
            return groups.value;
        if (inFlight && !force)
            return inFlight;
        loading.value = true;
        inFlight = groupsService
            .list()
            .then(({ groups: fetched }) => {
            groups.value = fetched || [];
            loaded.value = true;
            return groups.value;
        })
            .finally(() => {
            loading.value = false;
            inFlight = null;
        });
        return inFlight;
    }
    /** Fold a created or edited group back into the cache so every open picker sees it. */
    function upsert(group) {
        const index = groups.value.findIndex((existing) => existing.id === group.id);
        if (index === -1) {
            groups.value = [...groups.value, group].sort((a, b) => a.name.localeCompare(b.name));
        }
        else {
            groups.value = groups.value.map((existing) => (existing.id === group.id ? group : existing));
        }
    }
    function drop(id) {
        groups.value = groups.value.filter((group) => group.id !== id);
    }
    return { groups, loading, loaded, byId, fetchGroups, upsert, drop };
});
